import { render, staticRenderFns } from "./NewRoleMod.vue?vue&type=template&id=6e170d24&scoped=true"
import script from "./NewRoleMod.vue?vue&type=script&lang=js"
export * from "./NewRoleMod.vue?vue&type=script&lang=js"
import style0 from "./NewRoleMod.vue?vue&type=style&index=0&id=6e170d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e170d24",
  null
  
)

export default component.exports